import controller from './roles.controller';

const template = require('./roles.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/roles/roles.component.js